import { Reducer } from 'redux';
import { BreadcrumbModel } from '../../models/breadcrumb.model';
import { HeaderActions, HeaderActionTypes } from '../actions/header.action';

export interface HeaderState {
    readonly title?: string;
    readonly breadcrumbs?: BreadcrumbModel[];
    readonly status?: React.ReactNode;
    readonly actions?: React.ReactNode;
    readonly hideBreadcrumb?: boolean;
}

export const headerReducer: Reducer<HeaderState, HeaderActions> = (state = {}, action) => {
    switch (action.type) {
        case HeaderActionTypes.SET_TITLE: {
            return {
                ...state,
                title: action.value
            };
        }
        case HeaderActionTypes.SET_BREADCRUMB: {
            return {
                ...state,
                breadcrumbs: action.value
            };
        }
        case HeaderActionTypes.SET_STATUS: {
            return {
                ...state,
                status: action.value
            };
        }
        case HeaderActionTypes.SET_ACTIONS: {
            return {
                ...state,
                actions: action.value
            };
        }
        case HeaderActionTypes.HIDE_BREADCRUMB_BAR: {
            return {
                ...state,
                hideBreadcrumb: action.value
            };
        }

        default:
            return state;
    }
};